import { SessionContext } from 'widget/utils/session';
import { useContext } from 'react';
import type { SessionData } from 'widget/utils/session/contexts/SessionContext';

export default function useSession(): SessionData {
  const session = useContext<SessionData>(SessionContext);
  return session;
}
